import React from "react";
import { Box, Link } from "@mui/material";

interface NameCellProps {
  primaryText: string;
  secondaryText?: string;
  onClick?: () => void;
}

export const NameCell: React.FC<NameCellProps> = ({ primaryText, onClick }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        fontFamily: "Roboto, sans-serif",
      }}
    >
      <Link
        component="button"
        variant="body2"
        onClick={onClick}
        sx={{
          fontWeight: 500,
          textAlign: "left",
          textTransform: "none",
          cursor: onClick ? "pointer" : "default",
        }}
      >
        {primaryText}
      </Link>
    </Box>
  );
};
